var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    [
      _c("UserLimit"),
      _vm._v(" "),
      _c("SignalR", { attrs: { state: _vm.state } }),
      _vm._v(" "),
      _c("TimeTrackingNavbar", { ref: "navbar", attrs: { state: _vm.state } }),
      _vm._v(" "),
      _vm.state.loading
        ? _c(
            "div",
            { staticStyle: { height: "5em" } },
            [
              _c(
                "CenterOnParent",
                [_c("Spinner", { attrs: { type: "secondary" } })],
                1
              )
            ],
            1
          )
        : _c("TimeTracking", { attrs: { state: _vm.state } })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }